export default {
  props: {
    type: {
      type: String,
      default: 'button',
    },
    color: {
      type: String,
    },
    size: {
      type: String,
    },
    width: {
      type: String,
    },
    error: {
      type: Boolean,
    },
    pseudolink: {
      type: Boolean,
    },
    href: {
      type: String,
    },
    click: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    isSubmit() {
      return this.type === 'submit' ? this.type : false;
    },
    tag() {
      const BUTTON_TYPES = {
        button: 'button',
        submit: 'button',
        link: 'a',
      };

      return BUTTON_TYPES[this.type] || BUTTON_TYPES.button;
    },
  },
};
